<div class="position-reletivediv">
    <div class="popup-inner-space">
        <div class="betweenheader"> New Features </div>
        <div class="text-right flow-right">
            <img src="assets/images/close.svg" id="close" alt="..." class="img-fluid closeicon2 cursor-pointer"
                (click)="Close();">
        </div>
    </div>
    <div class="fxg-field input-field-w input-field-sigiup">
        <div class="fxg-field  margin-top-20 email-field-space">
                <div *ngFor="let feature of features">
                    <h2>{{ feature.title }}</h2>
                    <p>{{ feature.description }}</p>
                </div>
        </div>